import styles from "./HeaderSale.module.scss";
import moneybag from "../../../../src/assets/images/dashboard_icons/money_bag.png";

export default function HeaderSale() {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <span>Sprzedaż miesięczna:</span>
          <span className={styles.value}>5000 zł</span>
        </div>
        <img src={moneybag} alt="moneybag" />
      </div>
    </>
  );
}
